<template>
  <OurPage :title="$t('title.focusGroup.edit')" :back-route="backRoute" width="md">
    <FeatureForm ref="featureForm" v-model="form" edit-form />

    <template #footer-left>
      <OurButton class="button" :text="$t('button.save')" @click="onClickSaveButton" />

      <OurButton
        class="button"
        :text="$t('button.back')"
        variant="secondary"
        @click="$router.back()"
      />
    </template>
  </OurPage>
</template>

<script>
import { mapMutations } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import { customersQuery, featureQuery } from "./gql/queries";
import { updateFeatureMutation } from "./gql/mutations";
import FeatureForm from "./_components/FeatureForm.vue";

export default {
  name: "FocusGroupEdit",

  components: {
    FeatureForm,
  },

  mixins: [apolloMixin],

  data() {
    return {
      backRoute: {
        name: "Back",
        title: this.$t("title.focusGroup._"),
      },
      form: {
        customers: [],
        isActive: true,
      },
    };
  },

  created() {
    this.getCustomers();
    this.getFeature();
  },

  methods: {
    ...mapMutations("focusGroup", ["SET_CUSTOMERS"]),

    async getCustomers() {
      const { allCustomer } = await this.$get(customersQuery);

      if (allCustomer) {
        this.SET_CUSTOMERS(allCustomer);
      }
    },

    async getFeature() {
      const { feature } = await this.$get(featureQuery, { featureId: this.$route.params.id });

      if (feature) {
        this.form = { ...feature, customers: feature.customers.map((customer) => customer.id) };
      }
    },

    async onClickSaveButton() {
      this.$refs.featureForm.emitForm();

      const { updateFeature } = await this.$post(updateFeatureMutation, this.form, {
        delaySuccessNotify: true,
      });

      if (updateFeature.id) this.$router.back();
    },
  },
};
</script>
